import {Image} from "@mui/icons-material";
import FaqCategoriesEdit from "./FaqCategoriesEdit";
import FaqCategoriesCreate from "./FaqCategoriesCreate";
import FaqCategoriesList from "./FaqCategoriesList";

export default {
    list: FaqCategoriesList,
    edit: FaqCategoriesEdit,
    create: FaqCategoriesCreate,
    icon: Image,
};
